module.exports = __webpack_public_path__ + "static/media/background.83eb995b.jpg";